<template>
    <div class="start-assessment-section">

        <question-list-block
            ref="questionListBlockRef"
            :questions="generalQuestion.questions"
            :title="text('db.product.PROD_TITLE_GEN')"
            :questionsCountAnswered="generalQuestion.countAnswered"
            :questionsCountTotal="generalQuestion.countTotal"
            @onProvideAnswer="handleProvideAnswer"
            @emitQuestionClick="onQuestionClick"
            :shortcutNav="shortcutNav">
        </question-list-block>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import SymptomQuestionItem from "../../../common/components/shared/SymptomQuestionItem";
    import { mapGetters } from 'vuex';
    import RadialProgressSvg from "../../../common/components/svg/productList/radialProgress";
    import QuestionListBlock from "../../../common/components/shared/QuestionListBlock";

    export default {
        name: 'GeneralQuestions',
        components: {
            SymptomQuestionItem,
            RadialProgressSvg,
            QuestionListBlock
        },

        props: ["shortcutNav"],

        properties: {
            rotate: 270
        },
        methods: {
            handleProvideAnswer(data) {
                this.$store.dispatch('AssessmentStartStore/submitGeneralQuestionAnswer', data).then((response) => {
                    this.$emit('emitChangeAnswer', data);
                });
            },

            onQuestionClick(data) {

                data.crtPanel = "GENERAL_QUESTIONS";
                this.$emit('emitQuestionClick', data);
            }
        },
        computed: mapGetters({
            generalQuestion: 'AssessmentStartStore/getGeneralQuestion',
        })
    }

</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    /* ... */


</style>



// WEBPACK FOOTER //
// src/professional/components/assessment-start/GeneralQuestions.vue